module.exports = __webpack_public_path__ + "assets/img/write.20a8d0fd.svg";